import type { SimpleRequestConfig } from 'modules/app/types';
import type { ApiError, EmptyResponseBody, MetaAction } from 'modules/global/generic.types';
import type { DetailedIntervention } from 'modules/interventions/types/projections/detailed-intervention';
import * as actions from 'modules/leads/actions/core';
import * as types from 'modules/leads/actionTypes';
import type { DeleteLeadAction, FetchLeadsResponse, LeadsMeta, PaginatedLead } from 'modules/leads/types';

const WITHOUT_FAILURE_NOTIFICATION = { failure: () => undefined };

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.FETCH_REQUEST]: {
    callbacks: {
      success: (data: FetchLeadsResponse, meta: LeadsMeta) => actions.fetchSuccess(data, meta),
      failure: (error: ApiError, meta: MetaAction) => actions.fetchFailure(error, meta),
    },
    notifications: WITHOUT_FAILURE_NOTIFICATION,
  },
  [types.ASSIGN_REQUEST]: {
    callbacks: {
      success: (data: PaginatedLead, meta: MetaAction) => actions.assignSuccess(data, meta),
      failure: (error: ApiError, meta: MetaAction) => actions.assignFailure(error, meta),
    },
    notifications: {
      success: { id: 'page.leads.dashboard.notifications.assign.success', defaultMessage: 'Lead assigned' },
      failure: { id: 'page.leads.dashboard.notifications.assign.error', defaultMessage: "Can't update the lead" },
    },
  },
  [types.SET_STATUS_REQUEST]: {
    callbacks: {
      success: (data: PaginatedLead, meta: MetaAction) => actions.setStatusSuccess(data, meta),
      failure: (error: ApiError, meta: MetaAction) => actions.setStatusFailure(error, meta),
    },
    notifications: WITHOUT_FAILURE_NOTIFICATION,
  },
  [types.CREATE_DM_REQUEST]: {
    callbacks: {
      success: (data: DetailedIntervention, meta: MetaAction) => actions.createDirectMessageSuccess(data, meta),
      failure: (error: ApiError, meta: MetaAction) => actions.createDirectMessageFailure(error, meta),
    },
    notifications: WITHOUT_FAILURE_NOTIFICATION,
  },
  [types.DELETE_LEAD_REQUEST]: {
    callbacks: {
      success: (_: EmptyResponseBody, meta: MetaAction, { payload }: DeleteLeadAction) =>
        actions.deleteLeadSuccess(payload.leadId, meta),
      failure: (error: ApiError, meta: MetaAction) => actions.deleteLeadFailure(error, meta),
    },
    notifications: WITHOUT_FAILURE_NOTIFICATION,
  },
};

export default simpleRequests;
